module.exports = __webpack_public_path__ + "static/img/21.807c229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/21.png
// module id = u0s9
// module chunks = 10